import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { GetCompetitionsQuery,getCompetitionsQuery } from './query';

type Options = Omit<
  UseQueryOptions<
    GetCompetitionsQuery.Response,
    unknown,
    GetCompetitionsQuery.Response,
    ReturnType<typeof getCompetitionsQuery.getKey>
  >,
  'queryKey' | 'queryFn'
>;

export const useTradingCompetitions = (
  params: GetCompetitionsQuery.Param = {},
  options?: Options,
) => {
  return useQuery({
    queryKey: getCompetitionsQuery.getKey(params),
    queryFn: getCompetitionsQuery.getFn(params),
    ...options,
  });
};

